export default [
  { code: 36, label: "Deutschland" },
  { code: 1, label: "Afghanistan" },
  { code: 2, label: "Ägypten" },
  { code: 3, label: "Albanien" },
  { code: 4, label: "Algerien" },
  { code: 5, label: "Andorra" },
  { code: 6, label: "Angola" },
  { code: 7, label: "Antigua und Barbuda" },
  { code: 8, label: "Äquatorialguinea" },
  { code: 9, label: "Argentinien" },
  { code: 10, label: "Armenien" },
  { code: 11, label: "Aserbaidschan" },
  { code: 12, label: "Äthiopien" },
  { code: 13, label: "Australien" },
  { code: 14, label: "Bahamas" },
  { code: 15, label: "Bahrain" },
  { code: 16, label: "Bangladesch" },
  { code: 17, label: "Barbados" },
  { code: 18, label: "Belarus" },
  { code: 19, label: "Belgien" },
  { code: 20, label: "Belize" },
  { code: 21, label: "Benin" },
  { code: 22, label: "Bhutan" },
  { code: 23, label: "Bolivien" },
  { code: 24, label: "Bosnien und Herzegowina" },
  { code: 25, label: "Botsuana" },
  { code: 26, label: "Brasilien" },
  { code: 27, label: "Brunei" },
  { code: 28, label: "Bulgarien" },
  { code: 29, label: "Burkina Faso" },
  { code: 30, label: "Burundi" },
  { code: 31, label: "Chile" },
  { code: 32, label: "China" },
  { code: 33, label: "Cook-Inseln" },
  { code: 34, label: "Costa Rica" },
  { code: 35, label: "Dänemark" },
  { code: 37, label: "Dominica" },
  { code: 38, label: "Dominikanische Republik" },
  { code: 39, label: "Dschibuti" },
  { code: 40, label: "Ecuador" },
  { code: 41, label: "El Salvador" },
  { code: 42, label: "Elfenbeinküste" },
  { code: 43, label: "Eritrea" },
  { code: 44, label: "Estland" },
  { code: 45, label: "Fidschi" },
  { code: 46, label: "Finnland" },
  { code: 47, label: "Föderierte Staaten von Mikronesien" },
  { code: 48, label: "Frankreich" },
  { code: 49, label: "Gabun" },
  { code: 50, label: "Gambia" },
  { code: 51, label: "Georgien" },
  { code: 52, label: "Ghana" },
  { code: 53, label: "Grenada" },
  { code: 54, label: "Griechenland" },
  { code: 55, label: "Großbritannien" },
  { code: 56, label: "Guatemala" },
  { code: 57, label: "Guinea" },
  { code: 58, label: "Guinea-Bissau" },
  { code: 59, label: "Guyana" },
  { code: 60, label: "Haiti" },
  { code: 61, label: "Honduras" },
  { code: 62, label: "Indien" },
  { code: 63, label: "Indonesien" },
  { code: 64, label: "Irak" },
  { code: 65, label: "Iran" },
  { code: 66, label: "Irland" },
  { code: 67, label: "Island" },
  { code: 68, label: "Israel" },
  { code: 69, label: "Italien" },
  { code: 70, label: "Jamaika" },
  { code: 71, label: "Japan" },
  { code: 72, label: "Jemen" },
  { code: 73, label: "Jordanien" },
  { code: 74, label: "Kambodscha" },
  { code: 75, label: "Kamerun" },
  { code: 76, label: "Kanada" },
  { code: 77, label: "Kap Verde" },
  { code: 78, label: "Kasachstan" },
  { code: 79, label: "Katar" },
  { code: 80, label: "Kenia" },
  { code: 81, label: "Kirgisistan" },
  { code: 82, label: "Kiribati" },
  { code: 83, label: "Kolumbien" },
  { code: 84, label: "Komoren" },
  { code: 85, label: "Kongo, Demokratische Republik" },
  { code: 86, label: "Kroatien" },
  { code: 87, label: "Kuba" },
  { code: 88, label: "Kuwait" },
  { code: 89, label: "Laos" },
  { code: 90, label: "Lesotho" },
  { code: 91, label: "Lettland" },
  { code: 92, label: "Libanon" },
  { code: 93, label: "LIBERIA" },
  { code: 94, label: "Libysch-Arabische Dschamahirija" },
  { code: 95, label: "Liechtenstein" },
  { code: 96, label: "Litauen" },
  { code: 97, label: "Luxemburg" },
  { code: 98, label: "Madagaskar" },
  { code: 99, label: "Malawi" },
  { code: 100, label: "Malaysia" },
  { code: 101, label: "Malediven" },
  { code: 102, label: "Mali" },
  { code: 103, label: "Malta" },
  { code: 104, label: "Marokko" },
  { code: 105, label: "Marshall-Inseln" },
  { code: 106, label: "Mauretanien" },
  { code: 107, label: "Mauritius" },
  { code: 108, label: "Nordmazedonien" },
  { code: 109, label: "Mexiko" },
  { code: 110, label: "Moldawien" },
  { code: 111, label: "Monaco" },
  { code: 112, label: "Mongolei" },
  { code: 113, label: "Montenegro" },
  { code: 114, label: "Mosambik" },
  { code: 115, label: "Myanmar" },
  { code: 116, label: "Namibia" },
  { code: 117, label: "Nauru" },
  { code: 118, label: "Nepal" },
  { code: 119, label: "Neuseeland" },
  { code: 120, label: "Nicaragua" },
  { code: 121, label: "Niederlande" },
  { code: 122, label: "Niger" },
  { code: 123, label: "Nigeria" },
  { code: 124, label: "Niue" },
  { code: 125, label: "Nordkorea" },
  { code: 126, label: "Norwegen" },
  { code: 127, label: "Oman" },
  { code: 128, label: "Österreich" },
  { code: 129, label: "Pakistan" },
  { code: 130, label: "Palau" },
  { code: 131, label: "Panama" },
  { code: 132, label: "Papua-Neuguinea" },
  { code: 133, label: "Paraguay" },
  { code: 134, label: "Peru" },
  { code: 135, label: "Philippinen" },
  { code: 136, label: "Polen" },
  { code: 137, label: "Portugal" },
  { code: 138, label: "Republik Kongo" },
  { code: 139, label: "Ruanda" },
  { code: 140, label: "Rumänien" },
  { code: 141, label: "Russland" },
  { code: 142, label: "Salomonen" },
  { code: 143, label: "Sambia" },
  { code: 144, label: "Samoa" },
  { code: 145, label: "San Marino" },
  { code: 146, label: "São Tomé und Príncipe" },
  { code: 147, label: "Saudi-Arabien" },
  { code: 148, label: "Schweden" },
  { code: 149, label: "Schweiz" },
  { code: 150, label: "Senegal" },
  { code: 151, label: "Serbien" },
  { code: 152, label: "Seychellen" },
  { code: 153, label: "Sierra Leone" },
  { code: 154, label: "Simbabwe" },
  { code: 155, label: "Singapur" },
  { code: 156, label: "Slowakei" },
  { code: 157, label: "Slowenien" },
  { code: 158, label: "Somalia" },
  { code: 159, label: "Spanien" },
  { code: 160, label: "Sri Lanka" },
  { code: 161, label: "St. Kitts und Nevis" },
  { code: 162, label: "St. Lucia" },
  { code: 163, label: "St. Vincent und die Grenadinen" },
  { code: 164, label: "Südafrika" },
  { code: 165, label: "Sudan" },
  { code: 166, label: "Südkorea" },
  { code: 167, label: "Surinam" },
  { code: 168, label: "Eswatini" },
  { code: 169, label: "Syrien" },
  { code: 170, label: "Tadschikistan" },
  { code: 171, label: "Tansania" },
  { code: 172, label: "Thailand" },
  { code: 173, label: "Timor-Leste" },
  { code: 174, label: "Togo" },
  { code: 175, label: "Tonga" },
  { code: 176, label: "Trinidad und Tobago" },
  { code: 177, label: "Tschad" },
  { code: 178, label: "Tschechische Republik" },
  { code: 179, label: "Tunesien" },
  { code: 180, label: "Türkei" },
  { code: 181, label: "Turkmenistan" },
  { code: 182, label: "Tuvalu" },
  { code: 183, label: "Uganda" },
  { code: 184, label: "Ukraine" },
  { code: 185, label: "Ungarn" },
  { code: 186, label: "Uruguay" },
  { code: 187, label: "USA" },
  { code: 188, label: "Usbekistan" },
  { code: 189, label: "Vanuatu" },
  { code: 190, label: "Vatikanstadt" },
  { code: 191, label: "Venezuela" },
  { code: 192, label: "Vereinigte Arabische Emirate" },
  { code: 193, label: "Vietnam" },
  { code: 194, label: "Zentralafrikanische Republik" },
  { code: 195, label: "Zypern" },
  { code: 196, label: "Kosovo" },
  { code: 197, label: "Staatenlos" }
];
